export const TOKEN_KEY = 'token';
export const USER_KEY = 'user';
export const LANG_KEY = 'lang';
export const LOCALHOST = 'http://localhost';
